module.exports = __webpack_public_path__ + "media/svg-new/map-8ad31bd9.svg";